import { gql_request, GqlRequestOptions } from '@common/api-request';

import * as types from './catalog-product-browsing-type_types.2';

export function getCatalogBrowsingType(variable: types.GetCatalogBrowsingTypeVariables, options?: GqlRequestOptions) {
  const query = 'query GetCatalogBrowsingType($catalog_product_id: ID!, $browsing_type: String) { pdp_browsing_type(catalog_product_id: $catalog_product_id, browsing_type: $browsing_type) { type } }';
  return gql_request<types.GetCatalogBrowsingType, types.GetCatalogBrowsingTypeVariables>('GetCatalogBrowsingType', query, variable, { use_consumer: true, ...options });
}

